import { useNavigate } from "react-router-dom";
import { peutAjouterVehicule } from "../roles";

// LE PREMIER ÉCRAN D'UN CLIENT NEUF (05/10/2026, signalé par Yanis le jour de
// l'arrivée de deux nouveaux clients).
//
// Un compte sans véhicule arrivait sur un tableau de bord rempli de « 0 », sans
// rien qui dise quoi faire ensuite : le bouton d'ajout n'existait qu'en haut
// de la page Véhicules, qu'il fallait d'abord penser à ouvrir. La première
// action d'un client se décide ici.
//
// Le bouton suit la MÊME règle que le serveur (`peutAjouterVehicule`, double de
// `auth.ROLES_AJOUT_VEHICULE`) : administrateur ou travailleur. Aux autres, on
// dit qui peut le faire, plutôt que de montrer un bouton qui mènerait à un
// refus (voir VehiculesListe).
//
// `avecBoutons={false}` sur la page Véhicules : ses deux boutons sont déjà en
// haut de la page, et deux « + Ajouter un véhicule » à l'écran font hésiter.
export default function ParcVide({ user, avecBoutons = true }) {
  const navigate = useNavigate();

  if (peutAjouterVehicule(user) && !avecBoutons) {
    return (
      <section className="carte parc-vide">
        <h3>Votre parc est vide</h3>
        <p>
          Ajoutez vos véhicules un par un, ou importez-les d’un coup depuis un
          fichier Excel, avec les boutons en haut de la page.
        </p>
      </section>
    );
  }

  if (peutAjouterVehicule(user)) {
    return (
      <section className="carte parc-vide">
        <h3>Votre parc est vide</h3>
        <p>
          Ajoutez vos véhicules un par un, ou importez-les d’un coup depuis un
          fichier Excel.
        </p>
        <div className="actions-groupe">
          <button className="btn-accent" onClick={() => navigate("/vehicules/nouveau")}>
            + Ajouter un véhicule
          </button>
          <button className="btn" onClick={() => navigate("/vehicules?importer=1")}>
            Importer un fichier
          </button>
        </div>
      </section>
    );
  }

  // L'éditeur en consultation voit l'écran du client en lecture seule : lui
  // dire « demandez à votre administrateur » serait faux.
  const texte = user.role === "superadmin"
    ? "Ce client n’a encore aucun véhicule. Il les ajoute depuis un compte administrateur."
    : "Aucun véhicule pour le moment. Votre rôle ne permet pas d’en ajouter : demandez à l’administrateur de votre entreprise.";
  return (
    <section className="carte parc-vide">
      <h3>Votre parc est vide</h3>
      <p>{texte}</p>
    </section>
  );
}
